import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { AgentSkillService } from "@app/core/services/agent-skill.service";
import { ResultStatus } from "@app/core/models/result-status";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-manage-skill",
  templateUrl: "./manage-skill.component.html",
  styleUrls: ["./manage-skill.component.scss"],
})
export class ManageSkillComponent implements OnInit {
  skillList = [];
  @ViewChild("deleteSkillTemplate") deleteSkillTemplate: ElementRef;
  deleteID: any;
  public subModalRef: BsModalRef;
  constructor(
    private agentSkillService: AgentSkillService,
    public modalRef: BsModalRef,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.getSkills();
  }

  getSkills() {
    this.agentSkillService.getSkill().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.skillList = result.Data;
      }
    });
  }

  openDeleteConfirmation(id) {
    this.deleteID = id;
    this.subModalRef = this.modalService.show(
      this.deleteSkillTemplate,
      Object.assign({}, { class: "custom-modal update-modal modal-lg" })
    );
  }

  deleteSkill() {
    this.agentSkillService.deleteSkill(this.deleteID).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.subModalRef.hide();
        this.getSkills();
      }
    });
  }
}
